// extracted by mini-css-extract-plugin
module.exports = {"default":"anchor_default__RTtLT","inner":"anchor_inner__4lV12"};